
const sandTableApi = {
  // Only keep the API needed by QueryDetailInfo
  getJsSdkSignature: `${ZhbHost}/api/marketing/wecom/externalContact/jsSdkSignature`,
};

export { sandTableApi };
